
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Innovacrystacarrentalinvimannagar() {



    const cardData =
    {
        keyword: 'Innova Crysta Car Rental in Viman Nagar',
        heading: 'Meghana Cab : Innova Crysta Car Rental in Viman Nagar',
        headingDescription: 'Meghana Cab offers Innova Crysta Car Rental in Viman Nagar, delivering a luxurious, comfortable, and highly flexible travel solution tailored for Pune’s vibrant eastern suburb. Whether it’s local errands, sightseeing, airport transfers, corporate events, or outstation trips, our Innova Crysta vehicles are equipped with plush leather interiors, generous legroom, ample luggage capacity, and smooth air-conditioned comfort. With experienced and courteous chauffeurs, you get reliable door-to-door service directly from Viman Nagar—including locations like Koregaon Park, Kharadi bypass, or near the airport . Choose from hourly or full-day packages, one-way or round-trip options, and enjoy GPS tracking, transparent booking, and 24/7 customer support from Meghana Cab—ensuring your ride is always smooth, stylish, and tailored to your needs.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, a majestic 18th-century fortification built by the Peshwas of the Maratha Empire, stands as a powerful symbol of Pune's regal heritage. Although much of it was destroyed by fire in 1828, its massive gates, surviving stone walls, and sprawling gardens continue to attract visitors. The site hosts a captivating evening light-and-sound show that narrates stories of Maratha valor, betrayal, and political drama, making it a top cultural destination for history enthusiasts."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is an architectural marvel with wide Italian arches, spacious lawns, and historical significance. It played a key role in India’s freedom struggle, serving as the internment site for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. Today, it houses a museum dedicated to Gandhiji, preserving his personal belongings and memorials. This serene site blends colonial architecture with spiritual history, making it a peaceful retreat for visitors."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 30 km southwest of Pune, Sinhagad Fort rests atop a rugged cliff and is famous for the 1670 battle led by Tanaji Malusare. The trek to the fort offers a mix of adventure and natural beauty, with panoramic views of the Sahyadri Hills and the Khadakwasla Dam. At the summit, visitors can explore ancient bastions, a memorial dedicated to Tanaji, and enjoy local Maharashtrian snacks from food stalls. It's a must-visit spot for history lovers and trekkers alike."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Nestled in the upscale Koregaon Park area, the Osho International Meditation Resort is one of the world’s largest centers for personal growth and spiritual transformation. Spread over 28 acres of lush gardens, it offers meditation sessions, yoga, wellness therapies, swimming pools, and tranquil Zen gardens. Known for its serene atmosphere and international community, the resort provides a peaceful escape from city life and is ideal for those seeking relaxation, reflection, and inner peace."
  },
  {
    "title": "Dagadusheth Halwai Ganapati Temple",
    "description": "This iconic temple in the heart of Pune is dedicated to Lord Ganesha and is one of the most visited spiritual sites in Maharashtra. The deity’s idol is adorned with gold and precious ornaments and is especially celebrated during the Ganesh Chaturthi festival, drawing thousands of devotees. The temple is known for its continuous daily aartis and bustling yet peaceful ambiance. It is not only a spiritual landmark but also a symbol of community unity and devotion in Pune."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Carved out of a single rock in the 8th century, the Pataleshwar Cave Temple is an ancient shrine dedicated to Lord Shiva. It features a circular Nandi mandapa supported by elaborately carved stone pillars. Located near the bustling Jangli Maharaj Road, it offers a rare glimpse into India's rock-cut architectural traditions and serves as a peaceful spot for meditation amidst the urban rush. The temple’s heritage status makes it an essential stop for culture and architecture enthusiasts."
  },
  {
    "title": "Parvati Hill & Temple",
    "description": "Parvati Hill is one of Pune's most scenic viewpoints, rising about 2,100 feet above sea level. A 103-step stone staircase leads to a temple complex that includes shrines dedicated to Shiva, Vishnu, and Kartikeya. Built during the Peshwa rule, the site offers spectacular panoramic views of the city, especially at sunrise and sunset. The nearby museum showcases artifacts and portraits from Maratha history, making it both a spiritual and educational destination."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This unique museum, curated by Dr. Dinkar G. Kelkar in memory of his son, houses over 20,000 artifacts that showcase India’s rich cultural diversity. From musical instruments and sculptures to ancient utensils, paintings, and toys, each gallery offers a glimpse into everyday life across different eras and regions. The museum’s heritage architecture and recently added multilingual audio tours enhance the visitor experience, making it a treasure trove for cultural enthusiasts."
  },
  {
    "title": "Lal Mahal",
    "description": "Lal Mahal, originally constructed in 1630, was the residence of Shivaji Maharaj and his mother Jijabai during his formative years. Though rebuilt, it retains the grandeur of Maratha history and includes murals, life-size statues, and war-related exhibits that chronicle the early life and exploits of the great warrior king. Its central location near Shaniwar Wada makes it a significant stop on Pune’s Maratha heritage trail."
  },
  {
    "title": "Koregaon Park",
    "description": "Koregaon Park is Pune’s cosmopolitan hub known for its leafy lanes, upscale boutiques, and trendy cafés. Once a quiet residential area, it has evolved into a vibrant neighborhood housing the Osho Ashram, art galleries, and a lively nightlife scene. It offers a unique blend of spiritual tranquility and modern luxury, making it an ideal destination for both tourists and locals looking for recreation, shopping, and global cuisine in one place."
  }
],

  "services": [
    {
      "name": "Innova Crysta Rental Viman Nagar Pune",
      "description": "Hire an Innova Crysta in Viman Nagar, Pune, for comfortable and spacious travel. Whether for local travel or outstation trips, enjoy a smooth ride with premium amenities and professional service."
    },
    {
      "name": "Viman Nagar Innova Crysta Cab Hire",
      "description": "Book your Innova Crysta cab in Viman Nagar for daily commutes, airport transfers, or leisure trips. Experience hassle-free rides with reliable drivers and well-maintained vehicles."
    },
    {
      "name": "AC Innova Crysta Taxi Viman Nagar",
      "description": "Travel comfortably in our fully air-conditioned Innova Crysta taxis from Viman Nagar. Perfect for beating Pune's heat and enjoying a cool, relaxing journey."
    },
    {
      "name": "Chauffeur Driven Innova Crysta Viman Nagar",
      "description": "Our chauffeur-driven Innova Crysta service in Viman Nagar ensures professional, safe, and timely travel with courteous drivers knowledgeable of local routes."
    },
    {
      "name": "Online Booking Innova Crysta Viman Nagar",
      "description": "Easily book your Innova Crysta cab online in Viman Nagar with instant confirmation, transparent pricing, and flexible pick-up/drop options."
    },
    {
      "name": "Family Travel Innova Crysta Viman Nagar",
      "description": "Ideal for family trips, our Innova Crysta cabs offer spacious seating, ample luggage space, and child-friendly amenities for a comfortable ride in Viman Nagar."
    },
    {
      "name": "Business Travel Innova Crysta Viman Nagar",
      "description": "Make your business trips in Viman Nagar more productive and comfortable with our premium Innova Crysta rentals, ensuring punctuality and professionalism."
    },
    {
      "name": "Affordable Innova Crysta Rental Viman Nagar",
      "description": "Get budget-friendly Innova Crysta rentals in Viman Nagar without compromising on comfort or quality. Ideal for everyday travel or special occasions."
    },
    {
      "name": "Viman Nagar Local Innova Crysta Taxi",
      "description": "For local errands, sightseeing, or city tours within Viman Nagar, rent an Innova Crysta taxi that provides flexible, hourly rentals tailored to your needs."
    },
    {
      "name": "Viman Nagar Airport Transfer Innova Crysta",
      "description": "Reliable and timely airport transfer services from and to Pune Airport available with our Innova Crysta taxis based in Viman Nagar."
    },
    {
      "name": "Comfortable Innova Crysta Cab Viman Nagar",
      "description": "Enjoy comfortable rides in our Innova Crysta cabs with plush interiors, smooth suspension, and climate control — perfect for any journey from Viman Nagar."
    },
    {
      "name": "Premium Innova Crysta Hire Viman Nagar",
      "description": "Upgrade your travel with our premium Innova Crysta hire service in Viman Nagar, offering leather seats, spacious legroom, and exceptional service."
    },
    {
      "name": "Viman Nagar Sightseeing Innova Crysta",
      "description": "Explore local attractions around Viman Nagar with our sightseeing Innova Crysta service. Flexible routes and knowledgeable drivers make your trip enjoyable."
    },
    {
      "name": "Reliable Innova Crysta Taxi Viman Nagar",
      "description": "Count on us for dependable Innova Crysta taxi services in Viman Nagar with on-time pickups, safe driving, and courteous customer support."
    },
    {
      "name": "Group Travel Innova Crysta Viman Nagar",
      "description": "Travel comfortably with your group in our spacious Innova Crysta cabs, perfect for corporate outings, family gatherings, or social events in Viman Nagar."
    }
  ],
  "tableData": [
    ["Innova Crysta Rental Viman Nagar Pune", "Viman Nagar Innova Crysta Cab Hire"],
    ["AC Innova Crysta Taxi Viman Nagar", "Chauffeur Driven Innova Crysta Viman Nagar"],
    ["Online Booking Innova Crysta Viman Nagar", "Family Travel Innova Crysta Viman Nagar"],
    ["Business Travel Innova Crysta Viman Nagar", "Affordable Innova Crysta Rental Viman Nagar"],
    ["Viman Nagar Local Innova Crysta Taxi", "Viman Nagar Airport Transfer Innova Crysta"],
    ["Comfortable Innova Crysta Cab Viman Nagar", "Premium Innova Crysta Hire Viman Nagar"],
    ["Viman Nagar Sightseeing Innova Crysta", "Reliable Innova Crysta Taxi Viman Nagar"],
    ["Group Travel Innova Crysta Viman Nagar", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Innova Crysta Car Rental in Viman Nagar",
    "WhyChoosedescription": "Rent our premium Innova Crysta in Viman Nagar for a comfortable and stylish ride. Whether you need a vehicle for airport transfers, local errands, or city tours, our car rental service offers unmatched convenience."
  },
  {
    "WhyChooseheading": "Spacious and Comfortable Interiors",
    "WhyChoosedescription": "Our Innova Crysta cabs provide ample seating for up to 7 passengers, with plush seats and sufficient luggage space—perfect for family outings or business travel within and around Viman Nagar."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "Our experienced drivers ensure safe, timely, and courteous service. They are familiar with Viman Nagar and Pune city routes, providing smooth navigation and a hassle-free journey."
  },
  {
    "WhyChooseheading": "Well-Maintained and Hygienic Vehicles",
    "WhyChoosedescription": "All our Innova Crysta cars undergo regular maintenance and thorough cleaning, maintaining high hygiene standards to ensure a safe and pleasant ride for you and your companions."
  },
  {
    "WhyChooseheading": "Flexible Rental Options to Suit Your Needs",
    "WhyChoosedescription": "Choose from hourly rentals, daily hires, or customized packages tailored to your schedule and travel requirements in Viman Nagar and beyond."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Our pricing includes fuel, driver allowance, taxes, and tolls, providing full transparency and excellent value for your Innova Crysta rental."
  },
  {
    "WhyChooseheading": "Ideal for Airport Transfers, Local Travel, and Business Trips",
    "WhyChoosedescription": "Whether you’re heading to Pune Airport, attending meetings, or exploring the city, our Innova Crysta rental service in Viman Nagar offers comfort and reliability."
  },
  {
    "WhyChooseheading": "24/7 Customer Support and Easy Booking",
    "WhyChoosedescription": "Our customer service team is available around the clock to assist you with bookings, modifications, and any special requests, ensuring a smooth and convenient rental experience."
  }
]





















    }

const faqData = [
    {
        question: "How can I rent an Innova Crysta in Viman Nagar, Pune?",
        answer: "You can rent an Innova Crysta by calling Meghana Cab at +91 9075462128 or by booking online through our website for instant confirmation."
    },
    {
        question: "Is Innova Crysta available for local as well as outstation travel from Viman Nagar?",
        answer: "Yes, we offer Innova Crysta rentals for both local travel within Pune and outstation trips from Viman Nagar."
    },
    {
        question: "What are the rental packages available in Viman Nagar?",
        answer: "We provide flexible hourly packages (like 4H/40KM, 8H/80KM) and full-day rentals, along with customized outstation plans."
    },
    {
        question: "How many passengers can an Innova Crysta accommodate?",
        answer: "The Innova Crysta can comfortably seat 6 to 7 passengers along with ample luggage space."
    },
    {
        question: "Are your vehicles sanitized before every trip?",
        answer: "Yes, all vehicles are thoroughly cleaned and sanitized before every ride to ensure hygiene and safety."
    },
    {
        question: "Do you provide pickup from homes, hotels, or offices in Viman Nagar?",
        answer: "Yes, we offer door-step pickup and drop-off services anywhere in Viman Nagar."
    },
    {
        question: "Is the driver included in the rental service?",
        answer: "Yes, the rental includes a professional and courteous driver with knowledge of local and outstation routes."
    },
    {
        question: "Are the charges inclusive of fuel and driver allowance?",
        answer: "Yes, our standard rental fare includes fuel and driver allowance. Toll, parking, and extra hours may be charged separately."
    },
    {
        question: "Can I use the car for airport transfers from Viman Nagar?",
        answer: "Absolutely. We provide quick and reliable Innova Crysta airport drop/pickup services from Viman Nagar to Pune or Mumbai airports."
    },
    {
        question: "What payment options are available?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Sameer Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta from Viman Nagar for a day trip. Excellent condition, punctual service, and smooth ride.”',
    },
    {
        name: 'Ms. Natasha Mehra',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Very reliable and professional service. The car arrived on time in Viman Nagar, and the driver was courteous and helpful.”',
    },
];































































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];











const vimanNagarInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Innova Crysta Car Rental in Viman Nagar, Pune",
  "description": "Chauffeur-driven Innova Crysta car rental service in Viman Nagar Pune. Ideal for family travel, business trips, local sightseeing, airport transfers, and group travel. Affordable, premium, and reliable Innova Crysta cab hire in Viman Nagar.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Car Rental Service",
  "areaServed": {
    "@type": "Place",
    "name": "Viman Nagar, Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/innova-crysta-car-rental-viman-nagar-pune"
  }
};




    return (
        <div>

<Helmet>
  <title>Innova Crysta Car Rental in Viman Nagar Pune | Chauffeur Driven Taxi</title>
  <meta
    name="description"
    content="Book chauffeur-driven Innova Crysta cabs in Viman Nagar Pune for family trips, business travel, airport transfers, and sightseeing. Affordable and premium Innova Crysta car rental service."
  />
  <meta
    name="keywords"
    content="Innova Crysta Rental Viman Nagar Pune, Viman Nagar Innova Crysta Cab Hire, AC Innova Crysta Taxi Viman Nagar, Chauffeur Driven Innova Crysta Viman Nagar, Online Booking Innova Crysta Viman Nagar, Family Travel Innova Crysta Viman Nagar, Business Travel Innova Crysta Viman Nagar, Affordable Innova Crysta Rental Viman Nagar, Viman Nagar Local Innova Crysta Taxi, Viman Nagar Airport Transfer Innova Crysta, Comfortable Innova Crysta Cab Viman Nagar, Premium Innova Crysta Hire Viman Nagar, Viman Nagar Sightseeing Innova Crysta, Reliable Innova Crysta Taxi Viman Nagar, Group Travel Innova Crysta Viman Nagar"
  />
  <script type="application/ld+json">
    {JSON.stringify(vimanNagarInnovaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/14.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystacarrentalinvimannagar;